export default "__VITE_ASSET__DERiq$nA__"